export function itemCardActiveTabs() {
    let itemCardTabsArray = document.querySelectorAll('[id^="tab"]');
    itemCardTabsArray.forEach(function (itemCardTab) {
        itemCardTab.addEventListener('click', function () {
            setTimeout(function () {
                itemCardTabsArray.forEach(function (itemCardTab) {
                    itemCardTab.classList.remove('active');
                    itemCardTab.classList.add('inactive');
                });
                itemCardTab.classList.remove('inactive');
                itemCardTab.classList.add('active');

            }, 550);
        })
    });
}